import { Routes } from '@angular/router';
import { ExploreComponent } from './pages/explore/explore.component';
import { CategoriesComponent } from './pages/categories/categories.component';
import { AuthGuard } from '../auth/auth.guard';
import { MasterComponent } from '../layout/pages/master/master.component';
import { SearchComponent } from './pages/search/search.component';
var ɵ0 = {
    'showHeader': true
};
var routes = [
    {
        path: 'explore',
        component: MasterComponent,
        canActivate: [AuthGuard],
        data: ɵ0,
        children: [
            {
                path: '',
                component: CategoriesComponent
            },
            {
                path: ':category',
                component: ExploreComponent
            },
            {
                path: 'search/:query',
                component: SearchComponent
            }
        ]
    }
];
var ExploreRoutingModule = /** @class */ (function () {
    function ExploreRoutingModule() {
    }
    return ExploreRoutingModule;
}());
export { ExploreRoutingModule };
export { ɵ0 };
